var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"anchor"},[_c('hot-link',{attrs:{"href":_vm.computedHref},on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }